export const SET_POSITION_SLIDER = 'BEAMLY/CCX/SET_POSITION_SLIDER';
export const SET_STOP_DRAGGING_SLIDER = 'BEAMLY/CCX/SET_STOP_DRAGGING_SLIDER';
export const SET_TRACK_DIMENSIONS_SLIDER = 'BEAMLY/CCX/SET_TRACK_DIMENSIONS_SLIDER';
export const SET_VALUE_SLIDER = 'BEAMLY/CCX/SET_VALUE_SLIDER';

export const setValue = ({
  id,
  value,
  min,
  max,
}) => ({
  type: SET_VALUE_SLIDER,
  id,
  value,
  min,
  max,
});

export const setPosition = ({
  id,
  position,
  isDragging,
  min,
  max,
}) => ({
  type: SET_POSITION_SLIDER,
  id,
  position,
  isDragging,
  min,
  max,
});

export const setStopDragging = ({
  id,
  position,
  min,
  max,
}) => ({
  type: SET_STOP_DRAGGING_SLIDER,
  id,
  position,
  min,
  max,
});

export const setTrackDimensions = ({
  id,
  left,
  width,
  min,
  max,
}) => ({
  type: SET_TRACK_DIMENSIONS_SLIDER,
  id,
  left,
  width,
  min,
  max,
});
